import React, { useRef, useState, useEffect, useCallback } from "react";
import HTMLFlipBook from "react-pageflip";
import "./../css/App.css";
const logo = process.env.PUBLIC_URL + "/food.png";// ==============================
//  إعدادات عامة
// ==============================
const API_BASE = "https://suhba.education.com.ly/back";
//const ITEMS_PER_PAGE = 9; // شبكة 2 × 3 (بطاقتان بكل صف)

// بيانات تجريبية تُستخدم فقط إذا تعذّر الاتصال بالخادم،
// حتى تقدر تجرّب شكل الدفتر بدون تشغيل الـ API
// const DEMO_DATA = [
//   {
//     FoodName: "حلا الكاسات",
//     food_items: [
//       { ItemID: "d1", Name: "كاسات بستاشيو", ItemPrice: 12, FoodImage: null },
//       { ItemID: "d2", Name: "كاسات تريند دبي", ItemPrice: 12, FoodImage: null },
//       { ItemID: "d3", Name: "كاسات مانجا", ItemPrice: 12, FoodImage: null },
//       { ItemID: "d4", Name: "كاسات فروالة", ItemPrice: 12, FoodImage: null },
//       { ItemID: "d5", Name: "كاسات تيراميسو", ItemPrice: 14, FoodImage: null },
//       { ItemID: "d6", Name: "كاسات بوينو", ItemPrice: 14, FoodImage: null },
//     ],
//   },
//   {
//     FoodName: "كيك وتورتات",
//     food_items: [
//       { ItemID: "c1", Name: "تشيز كيك فراولة", ItemPrice: 18, FoodImage: null },
//       { ItemID: "c2", Name: "تورتة الشوكولاتة", ItemPrice: 20, FoodImage: null },
//       { ItemID: "c3", Name: "تورتة الليمون", ItemPrice: 18, FoodImage: null },
//       { ItemID: "c4", Name: "كيك الجزر", ItemPrice: 16, FoodImage: null },
//     ],
//   },
// ];

const STATE_LABELS = {
  user_fold: "سحب الصفحة",
  fold_corner: "طيّ الزاوية",
  flipping: "تقليب الصفحة",
  read: "وضع القراءة",
};

const ORIENTATION_LABELS = {
  portrait: "صفحة واحدة",
  landscape: "صفحتان متقابلتان",
};

// ==============================
//  مكوّنات الصفحات
// ==============================

// الغلاف (صفحة صلبة hard)
// const CoverPage = React.forwardRef(({ variant = "front", children }, ref) => (
//   <div className="dc-page dc-cover" ref={ref} data-density="hard">
//     <div className="dc-cover-inner">
//       <div className="dc-cover-seal">{variant === "front" ? "ح" : "❖"}</div>
//       {children}
//     </div>
//   </div>
// ));
const CoverPage = React.forwardRef(({ variant = "front", children }, ref) => (
  <div className="dc-page dc-cover" ref={ref} data-density="hard">
    <div className="dc-cover-inner">
      <div className="dc-cover-seal">
        {variant === "front" ? (
          <img src='https://suhba.education.com.ly/back/storage/ImageName/food.png' alt="صحبة طيبة" className="dc-cover-seal-img" />
         ) : (
         null
        )}
      </div>
      {children}
    </div>
  </div>
));
// صفحة محتوى عادية (soft)
const ContentPage = React.forwardRef(({ headerText, pageNumber, children }, ref) => (
  <div className="dc-page" ref={ref} data-density="soft">
    <div className="dc-page-inner">
      <div className="dc-page-header-wrap">
        <h2 className="dc-page-header">{headerText}</h2>
        <div className="dc-shelf-edge" />
      </div>
      <div className="dc-grid" dir="ltr">{children}</div>
      <div className="dc-page-footer">{pageNumber}</div>
    </div>
  </div>
));

// بطاقة صنف واحد داخل الشبكة
function ItemCard({ item }) {
  const [imgFailed, setImgFailed] = useState(false);
  const hasImage = Boolean(item.FoodImage) && !imgFailed;

  return (
    <div className="dc-card">
      <div className="dc-card-media">
        {hasImage ? (
          <img
            src={`https://suhba.education.com.ly/so7ba/public${item.FoodImage}`}
            alt={item.Name}
            onError={() => setImgFailed(true)}
          />
        ) : (
<div className="dc-card-media-fallback">🍽️</div>        )}
      </div>
      <div className="dc-card-name">{item.Name}</div>
      <div className="dc-card-price">{item.ItemPrice} $</div>
    </div>
  );
}

// ==============================
//  المكوّن الرئيسي
// ==============================
export default function App() {
  const bookRef = useRef(null);

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  //const [usingDemoData, setUsingDemoData] = useState(false);

  const [pageIndex, setPageIndex] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [orientation, setOrientation] = useState("landscape");
  const [flipState, setFlipState] = useState("read");
// const [isNarrow, setIsNarrow] = useState(window.innerWidth <= 480);

// useEffect(() => {
//   const onResize = () => setIsNarrow(window.innerWidth <= 480);
//   window.addEventListener("resize", onResize);
//   return () => window.removeEventListener("resize", onResize);
// }, []);

// const ITEMS_PER_PAGE = isNarrow ? 4 : 9;
const getItemsPerPage = (width) => {
  if (width <= 480) return 9;   // موبايل: عمودين × 2
  if (width <= 1024) return 9;  // آيباد/تابلت: 3 أعمدة × 2 صفوف
  return 15;                     // ديسكتوب: 3 × 3
};

const [itemsPerPage, setItemsPerPage] = useState(getItemsPerPage(window.innerWidth));

useEffect(() => {
  const onResize = () => setItemsPerPage(getItemsPerPage(window.innerWidth));
  window.addEventListener("resize", onResize);
  return () => window.removeEventListener("resize", onResize);
}, []);

const ITEMS_PER_PAGE = itemsPerPage;
  // جلب البيانات من الخادم، مع رجوع تلقائي للبيانات التجريبية عند الفشل
//   useEffect(() => {
//     let cancelled = false;

//     fetch(`${API_BASE}/api/food_items`)
//       .then((res) => {
//         if (!res.ok) throw new Error("bad response");
//         return res.json();
//       })
//       .then((data) => {
//         if (cancelled) return;
//         setCategories(data);
//         setLoading(false);
//       })
//       .catch((err) => {
//         console.warn("تعذّر الاتصال بالخادم، سيتم عرض بيانات تجريبية:", err);
//         if (cancelled) return;
//         setCategories(DEMO_DATA);
//         setUsingDemoData(true);
//         setLoading(false);
//       });

//     return () => {
//       cancelled = true;
//     };
//   }, []);
useEffect(() => {
  fetch(`${API_BASE}/api/getmenu`)
    .then((res) => res.json())
    .then((data) => {
      setCategories(data);
      setLoading(false);
    })
    .catch((err) => {
      console.error("خطأ في جلب بيانات المنيو:", err);
      setLoading(false);
    });
}, []);
  // أزرار التحكم
  const goPrev = useCallback(() => {
    bookRef.current?.pageFlip()?.flipPrev();
  }, []);

  const goNext = useCallback(() => {
    bookRef.current?.pageFlip()?.flipNext();
  }, []);

  const onInit = useCallback((e) => {
    setTotalPages(e.object.getPageCount());
    setPageIndex(e.data.page ?? 0);
    if (e.data?.mode) setOrientation(e.data.mode);
  }, []);

  const onFlip = useCallback((e) => setPageIndex(e.data), []);
  const onChangeOrientation = useCallback((e) => setOrientation(e.data), []);
  const onChangeState = useCallback((e) => setFlipState(e.data), []);

  

  // تقسيم كل تصنيف إلى صفحات بحد أقصى ITEMS_PER_PAGE لكل صفحة
  const pages = React.useMemo(() => {
  const result = [];
  categories.forEach((cat) => {
    const items = cat.food_items || [];
    if (items.length === 0) {
      result.push({ headerText: cat.FoodName, items: [] });
      return;
    }
    const totalCatPages = Math.ceil(items.length / ITEMS_PER_PAGE);
    for (let i = 0; i < items.length; i += ITEMS_PER_PAGE) {
      const pageItems = items.slice(i, i + ITEMS_PER_PAGE);
      const pageNumInCat = Math.floor(i / ITEMS_PER_PAGE) + 1;
      const title =
        totalCatPages > 1 ? `${cat.FoodName} (${pageNumInCat}/${totalCatPages})` : cat.FoodName;
      result.push({ headerText: title, items: pageItems });
    }
  });
  return result;
}, [categories, ITEMS_PER_PAGE]);

const { categoryList, categoryPageMap } = React.useMemo(() => {
  const list = [];
  const map = {};
  pages.forEach((page, idx) => {
    const baseName = page.headerText.replace(/\s*\(\d+\/\d+\)\s*$/, "");
    if (!(baseName in map)) {
      map[baseName] = idx + 1;
      list.push(baseName);
    }
  });
  return { categoryList: list, categoryPageMap: map };
}, [pages]);

const currentCategory =
  [...categoryList].reverse().find((name) => categoryPageMap[name] <= pageIndex) ||
  categoryList[0];

const jumpToCategory = useCallback(
  (name) => {
    const target = categoryPageMap[name];
    if (target != null) {
      bookRef.current?.pageFlip()?.flip(target);
    }
  },
  [categoryPageMap]
);
//   const pages = [];
//   categories.forEach((cat) => {
//     const items = cat.food_items || [];
//     if (items.length === 0) {
//       pages.push({ headerText: cat.FoodName, items: [] });
//       return;
//     }
    
//     const totalCatPages = Math.ceil(items.length / ITEMS_PER_PAGE);
//     for (let i = 0; i < items.length; i += ITEMS_PER_PAGE) {
//       const pageItems = items.slice(i, i + ITEMS_PER_PAGE);
//       const pageNumInCat = Math.floor(i / ITEMS_PER_PAGE) + 1;
//       const title =
//         totalCatPages > 1 ? `${cat.FoodName} (${pageNumInCat}/${totalCatPages})` : cat.FoodName;
//       pages.push({ headerText: title, items: pageItems });
//     }
//   });
// const categoryList = [];
// const categoryPageMap = {};
// pages.forEach((page, idx) => {
//   const baseName = page.headerText.replace(/\s*\(\d+\/\d+\)\s*$/, "");
//   if (!(baseName in categoryPageMap)) {
//     categoryPageMap[baseName] = idx + 1; // +1 لأن الغلاف الأمامي هو الصفحة 0
//     categoryList.push(baseName);
//   }
// });

// const currentCategory =
//   [...categoryList].reverse().find((name) => categoryPageMap[name] <= pageIndex) ||
//   categoryList[0];

// const jumpToCategory = (name) => {
//   const target = categoryPageMap[name];
//   if (target != null) {
//     bookRef.current?.pageFlip()?.flip(target);
//   }
// };
const bookChildren = React.useMemo(() => {
  const children = [
    <CoverPage key="cover-front" variant="front">
      <h1 className="dc-cover-title">قائمة الاصناف</h1>
      <div className="dc-cover-divider" />
      <p className="dc-cover-subtitle"> صحبة &amp; طيبة </p>
    </CoverPage>,
    ...pages.map((page, idx) => (
      <ContentPage key={`page-${idx}`} headerText={page.headerText} pageNumber={idx + 1}>
        {page.items.map((item, i) => (
          <ItemCard key={item.ItemID ?? i} item={item} />
        ))}
      </ContentPage>
    )),
    <CoverPage key="cover-back" variant="back">
      <h2 className="dc-cover-title dc-cover-title-sm">بالهناء والعافية</h2>
      <div className="dc-cover-divider" />
      <p className="dc-cover-subtitle">شكرًا لزيارتكم</p>
    </CoverPage>,
  ];
  return children;
}, [pages]);
if (loading) {
    return (
      <div className="dc-loading">
        <div className="dc-loading-spinner" />
        <p>جاري تحضير قائمة الاصناف...</p>
      </div>
    );
  }
  return (
    <div className="dc-stage-wrap" >
      {/* {usingDemoData && <div className="dc-demo-badge">عرض تجريبي (تعذّر الاتصال بالخادم)</div>} */}
<div className="dc-category-bar" role="tablist">
  {categoryList.map((name) => (
    <button
      key={name}
      type="button"
      className={`dc-category-chip ${currentCategory === name ? "is-active" : ""}`}
      onClick={() => jumpToCategory(name)}
    >
      {name}
    </button>
  ))}
</div>
      <div className="dc-book-glow">
        {/* <HTMLFlipBook
          width={520}
          height={680}
          size="stretch"
          minWidth={300}
          maxWidth={760}
          minHeight={420}
          maxHeight={980}
          showCover={true}
          usePortrait={true}
          mobileScrollSupport={true}
          maxShadowOpacity={0.5}
          flippingTime={700}
          className="dc-book"
          ref={bookRef}
          onInit={onInit}
          onFlip={onFlip}
          onChangeOrientation={onChangeOrientation}
          onChangeState={onChangeState}
        >
          <CoverPage variant="front">
            <h1 className="dc-cover-title">قائمة الحلويات</h1>
            <div className="dc-cover-divider" />
            <p className="dc-cover-subtitle"> حلويات  &amp; تورتينا </p>
          </CoverPage>

          {pages.map((page, idx) => (
            <ContentPage key={idx} headerText={page.headerText} pageNumber={idx + 1}>
              {page.items.map((item, i) => (
                <ItemCard key={item.ItemID ?? i} item={item} />
              ))}
            </ContentPage>
          ))}

          <CoverPage variant="back">
            <h2 className="dc-cover-title dc-cover-title-sm">بالهناء والعافية</h2>
            <div className="dc-cover-divider" />
            <p className="dc-cover-subtitle">شكرًا لزيارتكم</p>
          </CoverPage>
        </HTMLFlipBook> */}
        <div className="dc-book-glow">
  {/* <HTMLFlipBook
    width={520}
    height={680}
    size="stretch"
    minWidth={300}
    maxWidth={760}
    minHeight={420}
    maxHeight={980}
    showCover={true}
    usePortrait={true}
    mobileScrollSupport={true}
    maxShadowOpacity={0.5}
    flippingTime={700}
    className="dc-book"
    ref={bookRef}
    onInit={onInit}
    onFlip={onFlip}
    onChangeOrientation={onChangeOrientation}
    onChangeState={onChangeState}
  >
    {bookChildren}
  </HTMLFlipBook> */}
  {/* <HTMLFlipBook
  key={itemsPerPage}
  width={460}
  height={600}
  size="stretch"
  minWidth={280}
  maxWidth={680}
  minHeight={380}
  maxHeight={880}
  showCover={true}
  usePortrait={true}
  mobileScrollSupport={true}
  maxShadowOpacity={0.5}
  flippingTime={700}
  className="dc-book"
  ref={bookRef}
  onInit={onInit}
  onFlip={onFlip}
  onChangeOrientation={onChangeOrientation}
  onChangeState={onChangeState}
>
  {bookChildren}
</HTMLFlipBook> */}
<HTMLFlipBook
  key={itemsPerPage}
  width={420}
  height={800}
  size="stretch"
  minWidth={260}
  maxWidth={620}
  minHeight={350}
  maxHeight={800}
  showCover={true}
  usePortrait={true}
  mobileScrollSupport={true}
  maxShadowOpacity={0.5}
  flippingTime={700}
  className="dc-book"
  ref={bookRef}
  onInit={onInit}
  onFlip={onFlip}
  onChangeOrientation={onChangeOrientation}
  onChangeState={onChangeState}
>
  {bookChildren}
</HTMLFlipBook>
</div>
      </div>

      <div className="dc-controls">
        <button type="button" className="dc-btn" onClick={goPrev} disabled={pageIndex <= 0}>
          الصفحة السابقة
        </button>
        <span className="dc-page-counter">
          [{pageIndex + 1} من {totalPages || pages.length + 2}]
        </span>
        <button
          type="button"
          className="dc-btn"
          onClick={goNext}
          disabled={pageIndex >= totalPages - 1}
        >
          الصفحة التالية
        </button>
      </div>

      {/* <p className="dc-state-caption">
        طريقة العرض: {ORIENTATION_LABELS[orientation] || orientation} — الحالة:{" "}
        {STATE_LABELS[flipState] || flipState}
      </p> */}
    </div>
  );
}
